import { Outlet } from 'react-router-dom';
import { Layout } from '../components/layout/Layout';
import { ScrollToTop } from '../components/shared/ScrollToTop';

export function App() {
  return (
    <Layout>
      <ScrollToTop />
      <Outlet />
    </Layout>
  );
}
